import ClassificationViewState from '../../store/schema/classification/ClassificationViewState';
import MessageClassificationType from 'owa-service/lib/contract/MessageClassificationType';
import { InfoBarHostViewState } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import addMessageClassificationInfoBar from './addMessageClassificationInfoBar';
import setMessageClassification from '../../actions/classification/setMessageClassification';

export default function classifyMessage(
    viewState: ClassificationViewState,
    infoBarViewState: InfoBarHostViewState,
    classification: MessageClassificationType
) {
    const { messageClassification } = viewState;
    if (!messageClassification) {
        addMessageClassificationInfoBar(infoBarViewState);
    }
    setMessageClassification(viewState, classification);
}
